import { useState } from 'react';
import { motion } from 'framer-motion';
import { NavLink } from 'react-router-dom';
import { RiMenu2Fill } from 'react-icons/ri';

import { navLinks } from '../../utils/navLinks';
import Sidebar from '../Sidebar/Sidebar';
import logo from '../../assets/kw-logo.png';
import {
  logoAnimation,
  logoTransition,
  navbarAnimation,
  navbarTransition,
} from '../../animations/navbar';
import './Navbar.css';

const Navbar = () => {
  const [sidebar, setSidebar] = useState(false);
  const handleSidebar = () => {
    setSidebar(!sidebar);
  };

  return (
    <motion.div
      className="navbar"
      initial="out"
      animate="in"
      variants={navbarAnimation}
      transition={navbarTransition}
    >
      <motion.div
        className="navbar__logo"
        initial="out"
        animate="in"
        variants={logoAnimation}
        transition={logoTransition}
      >
        <NavLink className="navbar__logoLink" to="/">
          <img src={logo} alt="logo" />
        </NavLink>
      </motion.div>

      <ul className="navbar__menu">
        {navLinks.map((link) => {
          const { id, url, label } = link;
          return (
            <NavLink
              className="navbar__links"
              activeClassName="navbar__linksActive"
              key={id}
              to={url}
              exact
            >
              {label}
            </NavLink>
          );
        })}
      </ul>

      <label onClick={handleSidebar}>
        <RiMenu2Fill className="navbar__toggle" />
      </label>

      <Sidebar
        sidebar={sidebar}
        setSidebar={setSidebar}
        handleSidebar={handleSidebar}
      />
    </motion.div>
  );
};

export default Navbar;
